module.exports = __webpack_public_path__ + "img/cartao_amex.d792036d.svg";